import React from 'react';
import LateralMenu from '../LateralMenu';
import { faServer } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_stream_servers.png';
import collapsedLogo from '../../../assets/icon_cameras.png';

export default function StreamServersLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {
    const items = [{
        icon: faServer,
        text: translate('serverFarms'),
        action: () => navigation.navigate('StreamServers', { screen: 'ServerFarms' }),
        selected: selectedMenu == 'server-farms'
    },];

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            setOpen={setOpen}
            items={items}
            open={open}
            authenticatedUser={authenticatedUser}
        />
    );
}
